(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui/http-util"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui/http-util"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui/http-util")) : factory(root["underscore"], root["@bingads-webui/http-util"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__41__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 114);
/******/ })
/************************************************************************/
/******/ ({

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(115);


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ImageODataService", {
  enumerable: true,
  get: function get() {
    return _index.ImageODataService;
  }
});

var _index = __webpack_require__(116);

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageODataService = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _httpUtil = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ImageODataService {
  constructor({
    cid,
    aid,
    host,
    path,
    token,
    controller
  }) {
    this.cid = cid;
    this.aid = aid;
    this.host = host;
    this.path = path;
    this.token = token;
    this.controller = controller || 'Images';
  }
  /**
   * Get the images using the OData
   *
   * @param {Object} options - options for getting
   * @param {Number} options.top - top
   * @param {Number} options.skip - skip
   * @param {Object} options.customQueries - key value pair for the additional queries.
   *
   * @returns {Promise} - Promise of getting the images
   */


  getImages(options) {
    const defaultOptions = {
      top: 12,
      skip: 0,
      customQueries: {}
    };

    const optionsWithDefault = _underscore.default.defaults(options, defaultOptions);

    const url = `/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}`;

    const query = _underscore.default.extend({
      $top: optionsWithDefault.top,
      $skip: optionsWithDefault.skip
    }, optionsWithDefault.customQueries);

    return _httpUtil.odata.get(url, {
      data: query,
      host: this.host,
      path: this.path,
      oDataToken: this.token
    });
  }
  /**
   * Post image with the passed in data
   *
   * @param {Object} body - object containing the upload data
   *
   * @returns {Promise} - Promise reponse form the OData call
   */


  postImage(body) {
    const url = `/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}`;
    return _httpUtil.odata.post(url, {
      data: body,
      host: this.host,
      path: this.path,
      oDataToken: this.token
    });
  }
  /**
   * Patch image with the passed in data
   *
   * @param {Number} id - id of the image to patch
   * @param {Object} body - object containing the patch data
   *
   * @returns {Promise} - Promise reponse form the OData call
   */


  patchImage(id, body) {
    const url = `/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}(${id})`;
    return _httpUtil.odata.patch(url, {
      data: body,
      host: this.host,
      path: this.path,
      oDataToken: this.token
    });
  }
  /**
   * Delete image by the id passed in
   *
   * @param {Number} id - Id of the image to be deleted.
   *
   * @returns {Promise} - Promise response from the OData call.
   */


  deleteImage(id) {
    const url = `/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}(${id})`;
    return _httpUtil.odata.delete(url, {
      host: this.host,
      path: this.path,
      oDataToken: this.token
    });
  }
  /**
   * Get image by the id passed in
   *
   * @param {Number} id - Id of the iamge to be requested.
   *
   * @returns {Promise} - Promise response from the OData call.
   */


  getImage(id) {
    const url = `/Customers(${this.cid})/Accounts(${this.aid})/${this.controller}(${id})`;
    return _httpUtil.odata.get(url, {
      host: this.host,
      path: this.path,
      oDataToken: this.token
    });
  }

}

exports.ImageODataService = ImageODataService;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__41__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ })

/******/ });
});
